import React, {useMemo} from 'react'
import { deadlineObjectChecker } from '../../lib/utils';
import {ViewLabelValueField,VisDiv } from '../../components';
import {DataScadenzaCollaudo} from '../../lib/ScadenzeData'



/**
 * Component to display deadlines for a device with Collaudo and Revisione deadlines
 * #deadlines
 * @param {object} device - The device object
 * @param {object} deviceTemplate - The device template object
 * @param {object} registerTemplate - The register template object
 *  
 * @returns {JSX.Element} A JSX element displaying the deadlines
 */
const ScadenzaCollaudo = ({device, deviceTemplate, registerTemplate}) => {

    const testing = false
    const data = useMemo(() => (DataScadenzaCollaudo(device, deviceTemplate, registerTemplate)),[device,deviceTemplate, registerTemplate]);

    const {expiry, collaudo} = data

    const testFunction = () => {
        //console.log(DataScadenzaCollaudo(device, deviceTemplate, registerTemplate))
    }

        return (
            <div>

                <VisDiv rules={[testing]}><button onClick={()=>{testFunction()}}>Test deadlines</button></VisDiv>

                { collaudo?.date &&
                <ViewLabelValueField
                    label={collaudo.label}
                    value={ deadlineObjectChecker(collaudo?.dateObject).date}
                    highlight={ deadlineObjectChecker(collaudo?.dateObject).color}
                />}
                 { expiry?.date && 
                <ViewLabelValueField
                    label={expiry.label}
                    value={ deadlineObjectChecker(expiry?.dateObject).date}
                    highlight={ deadlineObjectChecker(expiry?.dateObject).color}
                /> }

            </div>
        )
    

}

export default ScadenzaCollaudo
